import { Flex, FormControl } from '@chakra-ui/react'
import { useState } from 'react'
import Modal from 'react-modal'
import { ButtonCmp } from '../ButtonCmp'
import { InputCmp } from '../InputCmp'
import { WhiteModal } from './styles'

interface iModalProps {
  isOpen: boolean
  title?: string
  onCreate: (texto: string) => void
  onClose: () => void
  tipo?: string
}

export const ModalCreateForm: React.FC<iModalProps> = ({ isOpen, title, tipo, onClose, onCreate }) => {
  const [Texto, setTexto] = useState('')

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName='react-modal-overlay'
      className='react-modal-content-default'
    >
      <WhiteModal>
        <FormControl>
          <InputCmp
            label={`Defina um nome para${tipo === 'Integracao' ? ' sua integração' : ' seu formulário'}`}
            value={Texto}
            OnChange={setTexto}
            type="text"
            placeholder='Digite o nome'
          />
        </FormControl>

        <Flex justifyContent={'end'} marginTop={'1rem'} gap={'.5rem'}>
          <ButtonCmp VarColor='c6' onClick={onClose}>Cancelar</ButtonCmp>
          <ButtonCmp VarColor='Green2' onClick={() => onCreate(Texto)}>Salvar</ButtonCmp>
        </Flex>
      </WhiteModal>
    </Modal>
  )
}
